module.exports = __webpack_public_path__ + "static/media/image_3.c1cbcffd.png";